var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3119 0C11.5287 0 11.7455 0.0471328 11.9435 0.136685L20.8186 3.90259C21.8555 4.34093 22.6285 5.36371 22.6237 6.59859C22.6002 11.2742 20.6772 19.8288 12.5562 23.7172C11.7691 24.0943 10.8547 24.0943 10.0676 23.7172C1.9466 19.8288 0.0235878 11.2742 2.14383e-05 6.59859C-0.00469184 5.36371 0.768285 4.34093 1.80521 3.90259L10.685 0.136685C10.8783 0.0471328 11.0951 0 11.3119 0ZM11.3119 3.14847V20.9694C17.8162 17.8162 19.5648 10.8452 19.6072 6.66457L11.3119 3.14847Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldyellow);
export default __webpack_public_path__ + "static/media/shield yellow.a2ed58a32d42fe5b15833a2d935f542e.svg";
export { ForwardRef as ReactComponent };